import { useState } from "react";

export interface WearDevice {
  id: string;
  nm: string;
  connected: boolean;
  icon: string;
}

export interface BioData {
  sleep: number;
  sleepTrend: number[];
  hrv: number;
  hrvTrend: number[];
  restHR: number;
  steps: number;
  activeMins: number;
  readiness: number;
  recovery: number;
  strain: number;
  lastSync: string;
}

const DEFAULT_DEVICES: WearDevice[] = [
  { id: "oura", nm: "Oura Ring Gen 3", connected: true, icon: "💍" },
  { id: "apple", nm: "Apple Watch Ultra", connected: true, icon: "⌚" },
  { id: "whoop", nm: "WHOOP 4.0", connected: false, icon: "📿" },
];

const DEFAULT_BIO: BioData = {
  sleep: 72,
  sleepTrend: [68, 71, 65, 72, 70, 68, 72],
  hrv: 42,
  hrvTrend: [38, 41, 39, 42, 44, 40, 42],
  restHR: 58,
  steps: 8420,
  activeMins: 47,
  readiness: 78,
  recovery: 82,
  strain: 14.2,
  lastSync: "3",
};

/** Connected wearables + simulated biometrics. Self-contained source of truth. */
export function useWearables() {
  const [wearDevices, setWearDevices] = useState<WearDevice[]>(DEFAULT_DEVICES);
  const [bioData, setBioData] = useState<BioData>(DEFAULT_BIO);
  return { wearDevices, setWearDevices, bioData, setBioData };
}